import Button from "components/buttons/Button"
import useTranslations from "hooks/useTranslations"
import useBookerDialog from "components/molecules/BookerDialog"
import cc from "classcat"

/**
 * The site-wide "book a meeting" call to action.
 *
 * It opens the cal.com booker in a dialog instead of navigating to it, so the
 * visitor stays on the site they came to — which on someturva.fi also means
 * they stay under Someturva's own header rather than landing on a page branded
 * for another market mid-funnel. The button keeps its href, so modified clicks
 * and a JavaScript-less visit still go straight to cal.com.
 */

type RequestButtonProps = {
  bgStyle?:
    | "primary"
    | "light"
    | "dark"
    | "blue"
    | "yellow"
    | "cadetblue"
    | "black"
    | "green"
  left?: boolean
}

const RequestButton = ({ bgStyle = "primary", left }: RequestButtonProps) => {
  const { hrHeroButton1, appointmentLink, bookerTitle, bookerLead } =
    useTranslations()

  const { onTriggerClick, dialog } = useBookerDialog({
    link: appointmentLink,
    title: bookerTitle || hrHeroButton1,
    lead: bookerLead,
    embedName: "request-button",
  })

  return (
    <div className={cc(["max-w-xs", left ? "" : "mx-auto"])}>
      <Button
        bgStyle={bgStyle}
        label={hrHeroButton1}
        link={appointmentLink}
        onClick={onTriggerClick}
        outbound
      />
      {dialog}
    </div>
  )
}

export default RequestButton
